import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { LeadService } from '../services/lead.service';
import { Quote } from '../../shared/models/quote.interface';
import { Router } from '@angular/router';
import { User } from '../../shared/models/user.interface';
import { JobType } from '../../shared/models/job.type.interface';
import { LeadFilter } from '../models/lead.filter';
import {RolePermission } from '../../shared/models/role.permission.enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

export interface DealerLeadSummary {
  leadCount: number;
  salespersons: User[];
  jobTypes: JobType[];
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent extends AbstractBiditComponent {
  leads: Quote[];

  summary: DealerLeadSummary;

  filter: LeadFilter = { jobTypeId: null, pastDue: false, salespersonId: '', projectName: '', dateRange: null, probability: '' } as LeadFilter;
  canAddLead: boolean = false;
  canEditLead: boolean = false;
  canAddQuote: boolean = false;

  constructor(deviceDetectorService: DeviceDetectorService, private router: Router, protected leadService: LeadService) {
    super(deviceDetectorService);
  }

  init() {
    this.canAddLead = LeadService.hasPermission(RolePermission.AddLead);
    this.canAddQuote = LeadService.hasPermission(RolePermission.AddQuote);
    this.canEditLead = LeadService.hasPermission(RolePermission.EditLead);

    this.loadSummary();
  } 

  loadSummary() {
    this.leadService.getSummary(this.filter)
      .subscribe({
        next: (data) => {
          this.summary = data;
        },
        error: (error: string) => this.onError(error)
      }); 
  }
}
